// Metadata for SchoolInfo sections and fields
export const SCHOOL_PROFILE_SECTIONS = [
    {
        key: 'basic',
        title: '',
        fields: [
            { name: 'tax_id', label: 'Tax ID', type: 'text', required: true },
            { name: 'school_colors', label: 'School Colors', type: 'text', required: true },
            { name: 'accreditation_status', label: 'Accreditation Status', type: 'select', required: true, options: ['Accredited', 'Not accredited', 'On probation', 'Other'] },
            { name: 'school_logo', label: 'School Logo (URL for POC)', type: 'text', required: true }
        ]
    },
    {
        key: 'primary_contact',
        title: 'Primary Contact',
        fields: [
            { name: 'contact_first_name', label: 'First Name', type: 'text', required: true },
            { name: 'contact_last_name', label: 'Last Name', type: 'text', required: true },
            { name: 'contact_title', label: 'Title', type: 'text', required: true },
            { name: 'contact_department', label: 'Department', type: 'text', required: true },
            { name: 'contact_email', label: 'Email', type: 'text', required: true },
            { name: 'contact_phone', label: 'Primary Phone', type: 'phone', required: true }
        ]
    },
    {
        key: 'secondary_contact',
        title: 'Secondary Contact',
        fields: [
            { name: 'secondary_contact_first_name', label: 'First Name', type: 'text', required: true },
            { name: 'secondary_contact_last_name', label: 'Last Name', type: 'text', required: true },
            { name: 'secondary_contact_title', label: 'Title', type: 'text', required: true },
            { name: 'secondary_contact_department', label: 'Department', type: 'text', required: true },
            { name: 'secondary_contact_email', label: 'Email', type: 'text', required: true },
            { name: 'secondary_contact_phone', label: 'Phone', type: 'phone', required: true }
        ]
    },
    {
        key: 'president',
        title: 'President',
        fields: [
            { name: 'president_first_name', label: 'First Name', type: 'text', required: true },
            { name: 'president_office_phone', label: 'Office Phone', type: 'phone', required: true },
            { name: 'president_last_name', label: 'Last Name', type: 'text', required: true },
            { name: 'president_email', label: 'Email', type: 'text', required: true }
        ]
    },
    {
        key: 'shipping',
        title: 'Shipping',
        fields: [
            { name: 'shipping_attention_first_name', label: 'Attention First Name', type: 'text', required: true },
            { name: 'shipping_attention_last_name', label: 'Attention Last Name', type: 'text', required: true },
            { name: 'shipping_attention_phone', label: 'Attention Phone', type: 'phone', required: true },
            { name: 'shipping_address_line1', label: 'Shipping Address Line 1', type: 'text', required: true },
            { name: 'shipping_address_line2', label: 'Shipping Address Line 2', type: 'text', required: false },
            { name: 'shipping_city', label: 'Shipping City', type: 'text', required: true },
            { name: 'shipping_state', label: 'Shipping State', type: 'states', required: true },
            { name: 'shipping_zip', label: 'Shipping ZIP', type: 'text', required: true },
            { name: 'athletic_conference_id', label: 'Athletic Conference', type: 'conferences', required: true }
        ]
    }
];

export default SCHOOL_PROFILE_SECTIONS;
